export default __webpack_public_path__ + "static/media/HotelShot.9f6850a0.jpg";